import React, { useEffect, useState } from 'react';
import { Alert, Container, Spinner } from 'react-bootstrap';
import { createAccessCeremony, type AccessCeremony } from '../../access/ceremony.ts';
import AccessCenter from './AccessCenter.tsx';

export default function AccessPage() {
  const [ceremony, setCeremony] = useState<AccessCeremony | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      setCeremony(createAccessCeremony());
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Court-access crypto could not start.');
    }
  }, []);

  if (error) {
    return (
      <div className="main-content access-center">
        <Container className="my-4">
          <h1 className="display-6">Court-access drill</h1>
          <Alert variant="danger">{error}</Alert>
        </Container>
      </div>
    );
  }

  if (!ceremony) {
    return (
      <div className="main-content access-center">
        <Container className="my-4">
          <Spinner animation="border" aria-hidden="true" />
        </Container>
      </div>
    );
  }

  return <AccessCenter ceremony={ceremony} />;
}
